// extracted by mini-css-extract-plugin
export var popupContainer = "styles-module__popupContainer___HS7eZ";
export var popupLocation = "styles-module__popupLocation___t3X4v";
export var closeButton = "styles-module__closeButton___xmt4t";
export var contentContainer = "styles-module__contentContainer____jaFI";